<template>
  <v-container>
    <v-card style="padding: 30px">
      <v-card-title
        >Kitob {{ isNew ? "qo'shish" : "o'zgartirish" }} <v-spacer />
      <c-s-v-upload />
      </v-card-title
      >
      <v-row>
        <v-col sm="12" md="6">
          <v-text-field
            label="NOMI"
            v-model="book.name"
            outlined
          ></v-text-field>
        </v-col>
        <v-col sm="12" md="6">
          <v-text-field
            label="AVTOR"
            v-model="book.author"
            outlined
          ></v-text-field>
        </v-col>
        <v-col sm="12" md="6">
          <v-text-field
            label="NASHR ETILGAN YIL"
            type="number"
            v-model="book.year"
            outlined
          ></v-text-field>
        </v-col>
        <v-col sm="12" md="6">
          <v-select
            :items="departments"
            :item-text="(item) => item.name"
            :item-value="(item) => item.id"
            label="KAFEDRA"
            v-model="book.departmentId"
            outlined
          ></v-select>
        </v-col>
        <v-col sm="12" md="6">
          <v-select
            :items="categories"
            :item-text="(item) => item.name"
            :item-value="(item) => item.id"
            v-model="book.categoryId"
            label="BO'LIM"
            outlined
          ></v-select>
        </v-col>
        <v-col sm="12" md="6" v-show="book.fileUrl === '' || book.fileUrl == null">
          <v-file-input
            show-size
            chips
            outlined
            @change="onFileUpload($event)"
            label="KITOB (PDF max 50MB)"
            accept="application/pdf"
          ></v-file-input
        ></v-col>
        <v-col v-if="book.fileUrl !== '' && book.fileUrl != null" sm="12" md="6">
          <v-row>
            <qrcode-vue
              class="mx-5"
              size="200"
              :value="`${uploadUrl}/${book.fileUrl}`"
            ></qrcode-vue>
            <a :href="`${uploadUrl}/${book.fileUrl}`">
              <img
                :src="`${uploadUrl}/${book.imageUrl}`"
                height="200px"
                width="auto"
                alt=""
              />
            </a>
            <v-btn
              class="mx-5"
              style="margin: auto 0"
              fab
              dark
              small
              color="primary"
              @click="clearFile()"
            >
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col sm="12" md="12">
          <v-row>
            <v-btn
              color="light-blue"
              @click="$router.push('/book')"
              class="mx white--text"
            >
              <v-icon>mdi-arrow-left</v-icon>
              Ortga</v-btn
            >
            <v-spacer />
            <v-btn class="mx" @click="save()" color="primary">Saqlash</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>


    <v-overlay :value="overlay">
      <v-progress-circular
          indeterminate
          color="primary"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar :value="snackbar" color="success" outlined right>
      id={{ book.id }} dagi kitob muvaffaqiyatli saqlandi!!
    </v-snackbar>
  </v-container>
</template>
<script>
import service from "./book.service";
import dService from "../department/department.service";
import cService from "../category/category.service";
import QrcodeVue from "qrcode.vue";
import CSVUpload from "@/components/book/CSVUpload";

export default {
  components: {
    CSVUpload,
    QrcodeVue,
  },
  data: () => ({
    uploadUrl: 'https://library.andqxai.uz/uploads',
    overlay: false,
    book: {
      name: "",
      author: "",
      year: "",
      departmentId: "",
      departmentName: "",
      categoryId: "",
      categoryName: "",
      fileUrl: "",
      imageUrl: "",
    },
    file: null,
    departments: [],
    categories: [],
    snackbar: false,
  }),
  methods: {
    getEntity(id) {
      service.getOne(id).then((res) => {
        this.book = res.data;
      });
    },
    getOtherEntities() {
      dService.getAll().then((res) => {
        this.departments = res.data;
      });
      cService.getAll().then((res) => {
        this.categories = res.data;
      });
    },
    initials() {
      this.getOtherEntities();
      if (!this.isNew) {
        this.getEntity(this.$route.params.id);
      }
    },

    onFileUpload(e) {
      this.file = e;
    },
    onUploadProgress(e) {
      console.log(e);
    },
    clearFile() {
      this.book.fileUrl = "";
      this.book.imageUrl = "";
    },

    save() {
      this.overlay = true;
      service.save(this.book).then((res) => {
        this.book = res.data;
        if (this.file != null) {
          service
              .saveBook(
                  res.data.id,
                  this.file,
                  this.onUploadProgress(this.$event)
              )
              .then((res) => {
                this.book = res.data;
                this.overlay = false;
                this.snackbar = true;
              }).catch(() => {
                this.overlay = false;
          })
        } else {
          this.snackbar = true;
          this.overlay = false;
        }
      }).catch(() => {
        this.overlay = false;

      });
    },
  },
  created() {
    this.initials();
  },
  computed: {
    isNew() {
      return !this.$route.params.id;
    },
  },
};
</script>
